import React from 'react'
// import { EMULATOR_TELEPHONE_UPDATE_URL } from '../constants'
import '../scss/login.scss'
import DropDown from './dropDown'

const UserTelephone = ({
  userToEdit,
  twilioNumber,
  setTwilioNumber
}) => {
  return (
    <div>
      <div
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <DropDown
            setTwilioUpdatedPhone={setTwilioNumber}
            userToEdit={userToEdit}
        />
      </div>
    </div>
  )
}

export default UserTelephone
